import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import HR from '@zg-rentals/multibrand-ui/lib/HR';
import Checkbox from '@zg-rentals/multibrand-ui/lib/Checkbox';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';

import UserManagementActions from 'app/shared/actions/UserManagementActions';

import './style.scss';

const propTypes = {
    onNextStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const Questions = ({
    currentUser,
    onNextStep,
    onCancel,
    dispatch,
    onBack,
}) => {
    const allProperties = currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES];
    const hasProperties = currentUser.properties.length > 0;
    const [hasLimitedProperties, setHasLimitedProperties] = React.useState(!allProperties && hasProperties);

    const handleSetSyncProperties = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: true,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
        setHasLimitedProperties(false);
    };

    const handleSetLimitedProperties = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: false,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
        setHasLimitedProperties(true);
    };

    return (
        <div>
            <Row>
                <Col>
                    <Text type="h3">Grant Property Access</Text>
                </Col>
            </Row>
            <Row>
                <Col className="Questions-header">
                    <Text type="h4">
                        {`Do you want ${currentUser.userName} to have access to all 
                        properties or selected properties?`}
                    </Text>
                </Col>
            </Row>
            <Row>
                <Col className="AddUserPage-questions">
                    <Checkbox
                        labelTextType="body"
                        onChange={handleSetSyncProperties}
                        checked={currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]}
                    >
                        <div>
                            <Text
                                className="Checkbox-label"
                                type="body"
                            >
                                All Properties
                            </Text>
                            <Text
                                type="body"
                                className="Checkbox-description"
                            >
                                This will automatically include any properties added in the future.
                            </Text>
                        </div>
                    </Checkbox>
                    <Checkbox
                        labelTextType="body"
                        onChange={handleSetLimitedProperties}
                        checked={hasLimitedProperties}
                    >
                        <div>
                            <Text
                                className="Checkbox-label"
                                type="body"
                            >
                                Selected properties
                            </Text>
                            <Text
                                type="body"
                                className="Checkbox-description"
                            >
                                You&apos;ll choose which properties
                                {` ${currentUser.userName} `}
                                can access.
                                Access to future properties must be granted manually.
                            </Text>
                        </div>
                    </Checkbox>
                </Col>
            </Row>
            <HR />
            <div className="Questions-footer">
                <Link className="Questions-button" onClick={onCancel}>
                    Cancel
                </Link>
                <div>
                    <Link className="Questions-button" onClick={onBack}>
                        Back
                    </Link>
                    <Button
                        type="primary"
                        onClick={onNextStep}
                        disabled={!(currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]
                            || hasLimitedProperties)}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

Questions.propTypes = propTypes;

export default connect(mapStateToProps)(Questions);
